import axios from 'axios'
import router from '@/router'
import source from '@/router'

const actions = {
    login({commit}, credentials) {
        return new Promise((resolve) => {
            axios.post('/api/login', credentials)
                .then((result) => {
                    if(result !== undefined) {
                        let response = Object.keys(result.data).length
                        let user_role = (result.data.user.role)
                        if (response !== 0) {
                            commit('login', result.data)

                            if(result.data.user.restrictions.pw === false) {
                                resolve('user/profile')
                            }

                            else {
                                if (user_role === 2) {
                                    resolve('deposit')
                                }
                                else {
                                    resolve('shop/home')
                                }
                            }
                        } else if (response === 0) {
                            commit('loginFailed')
                        }
                    }

                })
                .catch(() => {
                    commit('loginFailed')
                })
        })
    },

    logout({commit}) {
        axios.get('/api/logout').then(() => {
            commit('logout')
            router.go({name: 'Login'})
        })
    },

    async autoLogout({commit}, token) {
        commit('logout')
        router.go({name: 'Login'})
        await axios.get('/api/logout2', {
            headers: {
                Authorization: 'Bearer ' + token
            }
        })
        /*
        axios.get('/api/logout2', {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }).then(() => {
            commit('logout')
            router.go({name: 'Login'})
        })
        */
    },

    reinitializeLogin({commit}) {
        let token = JSON.parse(localStorage.getItem('token'))
        return new Promise(( )=> {
            axios.get('/api/user', {
                headers: {
                    Authorization: 'Bearer ' + token.token
                }
            }).then((result) => {
                let response = Object.keys(result).length
                if (response !== 0) {
                    let reinitializeData = []
                    reinitializeData.user = result.data[0]
                    commit('login', reinitializeData)
                } else if (response === 0) {
                    commit('loginFailed')
                }
            })
        })
    },

    setPassword({dispatch},data) {
      return new Promise(() => {
          axios.post('/api/setPassword', data)
              .then(() => {
                  dispatch('logout').then(() => {
                      router.push({name: 'Login'})
                  })
              })
      })
    },

    closeSnackbar({commit}, data) {
        commit('closeSnackbar', data)
    },

    setHeaderVisibility({commit}, data) {
        commit('setHeaderVisibility', data)
    },

    setOverlay({commit}, data) {
        commit('setOverlay', data)
    },

    setCartContent({commit}, data) {
        commit('setCartContent', data)
    },

    addToCart({commit}, data) {
        let newCartContent = data[0]
        newCartContent['setArguement'] = true
        return new Promise((resolve) => {
            axios.post('/api/setCartContent', newCartContent)
                .then((result) => {
                    commit('addToCart', result)
                    if(!data[2]) {
                      const notificationTxt = data[1].name + ' zum Warenkorb hinzugefügt'
                      commit('setNotificationTxt', notificationTxt)
                      commit('setShowNotification')
                    }
                    resolve(true)
                })
                .catch(() => {

                })
        })
    },

    importCSVToCart({commit}, data) {
        return new Promise((resolve) => {
            axios.post('/api/addFileToCart', data).then(response => {
                commit('addToCart', {data: response.data.cartContent})
                commit('retrieveCartContent', {data: {cartContent: response.data.cartContent, totalPrice: response.data.totalPrice}})
                commit('setNotificationTxt', 'CSV-Datei wurde erfolgreich importiert.')
                commit('setShowNotification')
                resolve(response)
                // resolve(response.data.cartContent)
            })
        })
        /*
        commit('addToCart', result)
        commit('setNotificationTxt', notificationTxt)
        commit('setShowNotification')
         */
    },

    removeFromCart({commit}, data) {
        let removedCartContent = data[0]
        removedCartContent['setArguement'] = false

        return new Promise(() => {
            axios.post('/api/setCartContent', removedCartContent)
                .then((result) => {
                    const notificationTxt = data[1].name + ' aus Warenkorb entfernt'
                    commit('removeFromCart', result)
                    commit('setNotificationTxt', notificationTxt)
                    commit('setShowNotification')
                })
                .catch(() => {

                })
        })
    },

    overwriteCartContent({commit}, data) {
        let params = {reorder: data}
        return new Promise(() => {
            axios.post('/api/overwriteCartContent', params)
                .then((result) => {
                    const notificationTxt = 'Dein Warenkorb wurde überschrieben'
                    commit('overwriteCartContent', result)
                    commit('setNotificationTxt', notificationTxt)
                    commit('setShowNotification')
                })
                .catch(() => {

                })
        })
    },

    mergeAddCartContent({commit}, data) {
        let params = {reorder: data}
        return new Promise(() => {
            axios.post('/api/mergeAddCartContent', params)
                .then((result) => {
                    const notificationTxt = 'Dein Warenkorb wurde angepasst.'
                    commit('overwriteCartContent', result)
                    commit('setNotificationTxt', notificationTxt)
                    commit('setShowNotification')
                })
                .catch(() => {

                })
        })
    },

    mergeCartContent({commit}, data) {
        let params = {reorder: data}
        return new Promise(() => {
            axios.post('/api/mergeCartContent', params)
                .then((result) => {
                    const notificationTxt = 'Dein Warenkorb wurde angepasst.'
                    commit('overwriteCartContent', result)
                    commit('setNotificationTxt', notificationTxt)
                    commit('setShowNotification')
                })
                .catch(() => {

                })
        })
    },

    updateTotalCartPrice({commit}, data) {
        commit('updateTotalCartPrice', data)
    },

    setLastWatched({commit}, data) {
        return new Promise(() => {
            axios.post('/api/setLastWatched/'+data)
                .then((result) => {
                    commit('setLastWatched', result)
                })
                .catch(() => {

                })
        })
    },

    setWatchList({commit}, data) {
        return new Promise(() => {
            axios.post('/api/setWatchList/'+ data)
                .then((result) => {
                    commit('setWatchList', result)
                })
                .catch(() => {

                })
        })
    },

    setDrawerVisibility({commit}) {
        commit('setDrawerVisibility')
    },

    async retrieveCartContent({commit}, data) {
        let url = '/api/cartContent'
        if(data) {
          url += '?date='+data
        }
        const response = await axios.get(url)
        commit('retrieveCartContent', response)
        return response
    },

    setLoadingState({commit}, data) {
        commit('setLoadingState', data)
    },

    setCategoryBreadcrumbs({commit}, data) {
        commit('setCategoryBreadcrumbs', data)
    },

    forwardToCategories({commit}) {
        commit('setCurrentCategory', null)
        router.push({path: '/shop/categories'})
    },

    forwardToWatchlist() {
        router.push({path: '/shop/watchlist'})
    },

    setCartDrawerState({commit}) {
        commit('setCartDrawerState')
    },

    sendDepositCollection({commit}, depositData) {
        let params = {deposit: depositData}
        let overlayParams = {visibility: true, state: 'waiting'}
        commit('setDepositOverlay', overlayParams)
        return new Promise((resolve) => {
            axios.post('api/issueDeposit', params, {timeout: 20000})
                .then(() => {
                    overlayParams = {visibility: true, state: 'success'}
                    commit('setDepositOverlay', overlayParams)
                    setTimeout(function() {
                        overlayParams = {visibility: false, state: null}
                        commit('setDepositOverlay', overlayParams)
                        resolve(true)
                    }, 2000)
                    //commit('sendDepositCollection')
                }).catch(() => {
                    overlayParams = {visibility: false, state: null}
                    commit('setDepositOverlay', overlayParams)
                    resolve(false)
            })
        }).catch(() => {

        })
    },

    sendDepositCollectionFromSavedState({commit}, depositData) {
        let params = {deposit: depositData}
        let overlayParams = {visibility: true, state: 'waiting'}
        commit('setDepositOverlay', overlayParams)
        return new Promise((resolve) => {
            axios.post('api/issueDeposit', params,{timeout: 20000})
                .then(() => {
                    overlayParams = {visibility: true, state: 'success'}
                    commit('setDepositOverlay', overlayParams)
                    setTimeout(function() {
                        overlayParams = {visibility: false, state: null}
                        commit('setDepositOverlay', overlayParams)
                        resolve(true)
                    }, 2000)
                }).catch(() => {
                    overlayParams = {visibility: false, state: null}
                    commit('setDepositOverlay', overlayParams)
                    resolve(false)
            })
        }).catch(() => {

        })
    },

    issueOrder({commit}, date) {
        let params = {date:date}
        let overlayParams = {visibility: true, state: 'waiting'}
        commit('setOverlay', overlayParams)
        axios.post('/api/issueOrder', params)
            .then(() => {
                commit('resetCart')
                overlayParams = {visibility: true, state: 'success'}
                commit('setOverlay', overlayParams)
                setTimeout(function() {
                    overlayParams = {visibility: false, state: null}
                    commit('setOverlay', overlayParams)
                    router.push({name: 'LastArticle'})
                }, 2000)
            })
    },

    fetchOrders(context, data) {
        let params = {timeOffset: data}
        return axios.post('/api/orders', params)
    },

    currentDayParser(context, date) {

        date.setDate(date.getDate() + 1)

        let dd = String(date.getDate()).padStart(2, '0')
        let mm = String(date.getMonth() + 1).padStart(2, '0')
        let yyyy = date.getFullYear()

        return yyyy + '-' + mm + '-' + dd

    },

    getArticlePic() {
        axios.get('api/pic', {
            cancelToken: source.token
        }).catch(function(thrown) {
            if (axios.isCancel(thrown)) {
                console.log('Request canceled', thrown.message);
            } else {
                // handle error
            }
        });
    },

    goToImprint({commit}) {
        commit('setDrawerVisibility')
        router.push({name: 'Impressum'})
    },

    getNews() {
        return new Promise(resolve => {
            axios.get('api/news').then((response) =>{
                resolve(response.data)
            })
        })
    },

    getNewsFile(context, newsId) {
        return new Promise((resolve) => {
            axios.get('api/getNewsFile/'+newsId,{
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',

                },
                responseType: 'arraybuffer',
            }).then((response) => {
                let file = new Blob([response.data])
                file.arrayBuffer().then(buffer => {
                    resolve(buffer)
                })
            })
        })
    },

    getNewsAvailable({commit}) {
        axios.get('api/newsAvailable').then((response) => {
            commit('setNewsAvailableState', response.data)
        })
    },

    addProductToLabels(context, article) {
        let price = null
        if(article.price.length > 0) {
            price = article.price[0].price
        }
        else if(article.price.length === 0) {
            price = article.default_price.uvp
        }

        let params = {
            artNr: article.itemNo,
            price: price
        }
        axios.post('api/addLabel', params).then(() => {
            return true
        })
    },

    getLabelFile() {
        return new Promise(() => {
            axios.get('api/createLabels',{
                headers: {
                    'accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                responseType: 'blob',
            }).then((response) => {
                let file = new Blob([response.data])
                const url = window.URL.createObjectURL(file);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'file.pdf'); //or any other extension
                document.body.appendChild(link);
                link.click();
            })
        })
    },

    getCurrentLabels() {
        return new Promise((resolve) => {
            axios.get('api/getSavedLabels').then((resp) => {
                resolve(resp.data)
            })
        })
    },

    updateLabel(context, params) {
        return new Promise((resolve) => {
            axios.post('api/updateLabel', params).then((resp) => {
                resolve(resp.data)
            })
        })
    },
    updateWatchlist(context, params) {
        axios.post('api/updateWatchlist', params)
    }
}

export default actions
